export default () => {

	const heroVideo = document.querySelector('.js-hero-video');
	const heroVideoMute = document.querySelector('.js-hero-video-mute');

	if (heroVideo && heroVideoMute) {
		const unmuteIcon = heroVideoMute.querySelector('.js-hero-video-icon-unmute');
		const muteIcon = heroVideoMute.querySelector('.js-hero-video-icon-mute');

		heroVideoMute.addEventListener('click', () => {
			if (heroVideo.muted) {
				heroVideo.muted = false;
				muteIcon.classList.remove('is-hidden');
				unmuteIcon.classList.add('is-hidden');
			}
			else {
				heroVideo.muted = true;
				muteIcon.classList.add('is-hidden');
				unmuteIcon.classList.remove('is-hidden');
			}
		});
	}

}